export const SITE = {
    name: "Aurassium Clinic",
    doctor: "Dr Souhali Massilia",
    address: "10 rue Vladimir Kramnik, 92600 Asnières-sur-Seine",
    // Fiche Google Business Profile officielle (lien de partage fourni par la cliente)
    mapsUrl: "https://share.google/T58HyyaS1bPAQYOMn",
    googleKgmid: "/g/11p1_3t_60",
    // Horaires d'ouverture, identiques à ceux de la fiche Google
    hours: [
        ["Lundi", "10h30 – 17h30"],
        ["Mardi", "10h30 – 17h30"],
        ["Mercredi", null],
        ["Jeudi", "10h30 – 17h30"],
        ["Vendredi", "10h30 – 17h30"],
        ["Samedi", null],
        ["Dimanche", null],
    ],
    rpps: "10109434349",
    siret: "99043517400018",
    // Lien Doctolib configurable : renseigner l'URL pour activer le bouton « Ouvrir Doctolib ».
    doctolibUrl: "https://www.doctolib.fr/medecin-generaliste/asnieres-sur-seine/massilia-souhali",
    instagram: "aurassium.clinic",
    instagramUrl: "https://www.instagram.com/aurassium.clinic/",
};
